export default {
  'form.date.placeholder.start': '开始日期',
  'form.date.placeholder.end': '结束日期',
  'form.type.all': '全部',
  'form.changetype.new': '新增',
  'form.changetype.edit': '编辑',
  'form.changetype.delete': '删除',
};
